<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.lxth">
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">Continues Annealing Furnace</span>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span
          style="font-size:12.0pt;font-family:宋体;"
        >Copper tube induction continuous annealing device is a special induction continuous annealing device for copper tubes. It uses an intermediate frequency power to continuously supply the electrical energy to the copper tubes by inductively coupling, and anneals the copper tubes on-line to change the metal crystal structure, improve the processing performance of the copper tubes, improve the yield and product quality.</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <div align="center">
        <table
          style="width:375.0pt;"
          class="ke-zeroborder"
          border="0"
          cellpadding="0"
          cellspacing="0"
          width="500"
        >
          <tbody>
            <tr>
              <td style="background:#F4F4F4;">
                <p style="text-align:center;" align="center">
                  <b>
                    <span
                      style="font-size:11.5pt;line-height:150%;font-family:宋体;color:#000099;"
                    >Main Performance Parameter</span>
                  </b>
                  <span style="font-size:11.5pt;line-height:150%;font-family:Arial;color:#000099;"></span>
                </p>
              </td>
            </tr>
            <tr>
              <td valign="top">
                <div align="center">
                  <table
                    style="width:375.0pt;background:black;"
                    class="ke-zeroborder"
                    border="0"
                    cellpadding="0"
                    cellspacing="1"
                    width="500"
                  >
                    <tbody>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >1</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、Annealed Material</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Phosphorus Anaerobic Copper</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >TU1</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、Copper</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >T1-T4</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >2</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、Copper Pipe Specifications</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Min.</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >Φ7×0.3mm</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >&nbsp;</span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Max.</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >Φ13×0.5mm</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >According to requirements of customers, one or more sets of induction heaters can be provided on the basis of the specifications of copper pipes.</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >3</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、Annealing Temperature</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Rated</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >700</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >℃</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >4</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、Rated Speed</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >300 m</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >，</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >400 m</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >∕min</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >For</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >Φ9.52×0.37</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >copper pipes，rated speed is</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >400 m</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >，and speed range is</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >30</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >∽</span>
                            <span style="font-size:9.0pt;line-height:150%;color:black;">
                              300
                              m
                            </span>
                            <span style="font-size:9.0pt;line-height:150%;color:black;">∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >For</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >Φ12.7×0.5</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >copper pipes，rated speed is</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >400 m</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >，and speed range is</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >30</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >∽</span>
                            <span style="font-size:9.0pt;line-height:150%;color:black;">
                              300
                              m
                            </span>
                            <span style="font-size:9.0pt;line-height:150%;color:black;">∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >Speed Governing Accuracy</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >
                              &nbsp;
                              &nbsp;
                            </span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >Surpass</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >0.1%</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >5</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、Total Installed Capacity</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >880 kW</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >（</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >300 m</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >）</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >
                              <br>980 kW
                            </span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >（</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >400 m</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >∕min</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >）</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >Induction Heater Power</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >2×350 kW</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >Transmission Motor Power</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >70kW</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >Control System Power</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >10kW</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >&nbsp;&nbsp;</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >Cooling Water System</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Installed Capacity</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >—100kW</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >6</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、IF Power</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Output Power</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >2×350 kW</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >，</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >2×400 kW</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Output Voltage</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >750V</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Input Voltage</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >380V</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Working Frequency</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >8000Hz</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Cooling Water</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Water Volume</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >24t/h</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >(Including electric capacitor cooling), water pressure</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >0.2-0.4MPa</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >7</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、Induction Heater</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Power Factor</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >0.9</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Electrothermal Efficiency</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >0.32—0.4</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="244">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Clean Water Cooling</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="253">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Water Volume</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >56t/h</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >，Water Pressure</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >0.3-0.4MPa</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >8</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >、Cooling Water System</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" style="background:white;" width="498">
                          <p style="text-align:left;" align="left">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >Clean water closed circuit cooling system is adopted. The total circulating water volume is</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >98t/h</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >and the water pressure is</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >0.3-0.4Mpa</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >. Among them: the induction heater cooling system is</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >56t/h</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >; the intermediate frequency power supply cooling system is</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >24t/h</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >(including electric heating capacitors); the quenching water system is</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            >18t/h</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:black;"
                            >. (The cooling water system is initially selected to use special water cooling equipment for induction furnaces manufactured by Wuxi Ark Water Cooling Equipment Factory. The specific configuration is the responsibility of the customers.)</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p style="text-align:center;" align="center">
                  <span style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:black;"></span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        lxth: require("../../../assets/img/common/lxth.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/lxth.vue